import useStore from "config/store";
import minArrayObjectElement from "utils/minArrayObjectElement";

/** The logged-in user's `isNewraiUser` and main group, from `getUserByToken`. */
export default function useCurrentUserGroups() {
  const userData = useStore(state => state.userData);
  const groupDefault = minArrayObjectElement(userData?.groups, "order");

  return {
    isNewraiUser: !!userData?.isNewraiUser,
    groupDefaultOrder: groupDefault?.order,
  };
}
